import axios from 'axios';

const apiIntents = {
    get(params, idToken, cancelToken, index, selectedTab) {
        let headers = {
            Authorization: 'Bearer ' + idToken,
            'X-From': location.href
        };
        // デモモードのときはすべてのキーワードのタブで記事対策キーワードの条件に該当しないインテント表示にしたい
        if (process.env.VUE_APP_ENV === 'demo' && selectedTab == 'all') {
            headers['x-api-fake-when-priority'] = false;
        } else if (
            index &&
            (process.env.VUE_APP_ENV === 'local' ||
                process.env.VUE_APP_ENV === 'demo' ||
                process.env.VUE_APP_ENV === 'prototype')
        ) {
            headers['x-api-fake-when-index'] = index;
        }
        return axios.get(`${process.env.VUE_APP_APIURL}/intents`, {
            headers: headers,
            params: params,
            cancelToken: cancelToken
        });
    }
};
export default apiIntents;
